import React, { useState, useRef } from "react";
import { Link } from "react-router-dom";
import {
  Form,
  Input,
  Row,
  Modal,
  Typography,
  Button,
  Col,
  notification,
  Select,
} from "antd";
import UserContactApi from "../../Apis/UserContactApi";
const { Title } = Typography;
function Contact({ visible, onClose }) {
  const [form] = Form.useForm();
  const [form2] = Form.useForm();
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const UserDetails = JSON.parse(localStorage.getItem("UserDetails"));
  const [modalVisible, setModalVisible] = useState(false);
  const [ResentOtpLable, setResentOtpLable] = useState(false);
  const [otp, setOtp] = useState(["", "", "", "", "", ""]);
  const [selectedContact, setSelectedContact] = useState("");

  const inputRefs = useRef([]);


  const handleClickResendOTP = () => {
    const isOtpValid = otp.every((digit) => digit !== "");

    let formData = JSON.stringify({
      userId: decodedToken?.userId,
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    });
    UserContactApi.OTPResent(formData)
      .then((response) => {
        setResentOtpLable(false);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>OTP</span>,
          description: "OTP Send Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        clearForm();
      })
      .catch((err) => {
        setResentOtpLable(true);
        console.log(err);
        // Error Notification
        if (err.apiError.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>Error</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  const handleSubmitOTP = () => {
    let formData = JSON.stringify({
      userId: decodedToken?.userId,
      otp: otp.join(""),
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    });
    UserContactApi.OTPValid(formData)
      .then((response) => {
        setResentOtpLable(false);
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>OTP</span>,
          description: "OTP Verified Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        onClose();
        setModalVisible(false);
        clearForm();
        form.resetFields();
      })
      .catch((err) => {
        setResentOtpLable(true);
        console.log(err);
        // Error Notification
        if (err.apiError.status) {
          notification.open({
            message: <span style={{ fontWeight: "bold" }}>Error</span>,
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };

  const handleSubmit = (data) => {
    let formData = JSON.stringify({
      contactType: data.contactType,
      contactValue: data.contactValue,
      userDTO: {
        id: decodedToken?.userId,
      },
      tenantDTO: {
        id: decodedToken?.tenantId,
        tenantApiKey: decodedToken?.tenantApiKey,
      },
    });

    UserContactApi.CreateContactsApi(formData)
      .then((response) => {
        if (data.contactType === "MOBILE") {
          return handleButtonClick();
        }
        onClose();
        notification.open({
          message: <span style={{ fontWeight: "bold" }}>Created</span>,
          description: "Created Successfully",
          closeIcon: false,
          duration: 3,
          style: {
            backgroundColor: "#b3ffb3",
            color: "green",
          },
        });
        form.resetFields();
      })
      .catch((err) => {
        console.log(err);
        // Error Notification
        if (err.apiError.status) {
          notification.open({
            message: (
              <span style={{ fontWeight: "bold" }}>Error</span>
            ),
            description: err.apiError.message,
            closeIcon: false,
            duration: 3,
            style: {
              backgroundColor: "#fff2f0",
              color: "red",
            },
          });
        }
      });
  };


  const handleSelectChange = (value) => {
    setSelectedContact(value);
  };

  const validateInputNumber = (_, value) => {
    if (selectedContact === "MOBILE") {
      if (value >= 0) {
        return Promise.resolve();
      }
      return Promise.reject(new Error("Please enter valid number"));
    } else if (selectedContact === "EMAIL") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (emailRegex.test(value)) {
        return Promise.resolve();
      }
      return Promise.reject(new Error("Please enter valid Email"));
    } else {
      if (value) {
        return Promise.resolve();
      }
      return Promise.reject(new Error("Please enter Number"));
    }
  };

  const handleChangeOtp = (value, index) => {
    if (value.length <= 1) {
      const newOtp = [...otp];
      newOtp[index] = value;
      setOtp(newOtp);
      if (value.length === 1 && inputRefs.current[index + 1]) {
        inputRefs.current[index + 1].focus();
      }
    }
    console.log(index);
  };
  const handleButtonClick = () => {
    setModalVisible(true);
  };
  const handleButtonClose = () => {
    setModalVisible(false);
  };
  const clearForm = () => {
    setOtp(["", "", "", "", "", ""]);
  };
  return (
    <>
      <Modal
        footer={[]}
        width={600}
        visible={visible}
        onCancel={onClose}
        maskClosable={false}
        onOk={onClose}
      >
        <Title level={4} className="text-center Primary-Font mb-4 pb-3">
          User Contacts
        </Title>
        <Form
          form={form}
          name="nest-messages"
          layout="horizontal"
          labelCol={{
            span: 24,
          }}
          wrapperCol={{
            span: 24,
          }}
          className="FormClass IndividualProduct-Model"
          onFinish={handleSubmit}
        >
          <>
            <Row gutter={24}>
              <Col span={11}>
                <Form.Item
                  name="contactType"
                  label="Type"
                  className="text-lable"
                  rules={[
                    {
                      required: true,
                      message: "Please Select Type",
                    },
                  ]}
                >
                  <Select
                    onChange={handleSelectChange}
                    className="control-Select mb-1"
                    placeholder="Select Type"
                  >
                    <option value="HOME">Home</option>
                    <option value="MOBILE">Mobile</option>
                    <option value="WORK">Work</option>
                    <option value="EMAIL">Email</option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={13}>
                <Form.Item
                  name="contactValue"
                  label="text"
                  className="text-lable"
                  rules={[
                    {
                      validator: validateInputNumber,
                    },
                  ]}
                >
                  <Input
                    type='text'
                    placeholder={`${selectedContact}`}
                    className="control-input"
                  />
                </Form.Item>
              </Col>
            </Row>

            <div className="d-flex justify-content-center pt-1">
              <Button
                type="primary"
                htmlType="submit"
                className="btn btn-primary btn-save mx-2"
                style={{ width: "37%" }}
              >
                Save
              </Button>

            </div>
          </>
        </Form>

      </Modal>
      <Modal
        title="Enter OTP"
        visible={modalVisible}
        width={400}
        onCancel={handleButtonClose}
        footer={null}
        maskClosable={false}
      >
        <Form
          form={form2}
          name="nest-messages"
          onFinish={handleSubmitOTP}
          layout="horizontal">
          <Row gutter={24}>
            <Col span={24}>
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                }}
              >
                {otp.map((digit, index) => (
                  <Form.Item key={index} style={{ width: "16%" }}>
                    <Input
                      ref={(input) =>
                        (inputRefs.current[index] = input)
                      }
                      id={`otpInput-${index}`}
                      maxLength={1}
                      onChange={(e) =>
                        handleChangeOtp(e.target.value, index)
                      }
                      value={digit}
                    />
                  </Form.Item>
                ))}
              </div>
            </Col>
            <Col span={24}>
              <Button
                type="primary"
                htmlType="submit"
                className="btn btn-primary btn-save mx-2"
                style={{ width: "100%", height: "50px" }}
              >
                Save
              </Button>
              <div className="d-flex justify-content-center">
                <Link
                  to={""}
                  className="pt-3"
                  onClick={handleClickResendOTP}
                >
                  <u>Resend OTP</u>
                </Link>
              </div>

            </Col>
          </Row>
        </Form>
      </Modal>
    </>
  );
}

export default Contact;
